import { render, staticRenderFns } from "./PublicEventMessages.vue?vue&type=template&id=2d63711a&scoped=true"
import script from "./PublicEventMessages.vue?vue&type=script&lang=js"
export * from "./PublicEventMessages.vue?vue&type=script&lang=js"
import style0 from "./PublicEventMessages.vue?vue&type=style&index=0&id=2d63711a&prod&lang=scss"
import style1 from "./PublicEventMessages.vue?vue&type=style&index=1&id=2d63711a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63711a",
  null
  
)

export default component.exports